import { FC } from 'react';
import { DataCellProps } from '../types';
import { Edit } from '@mui/icons-material';
import styled from 'styled-components';
import EllipsisText, { TextContainer } from 'components/EllipsisText';

export const StyledEditIcon = styled(Edit)`
  font-size: 1rem;
  color: #376fd0;
`;

const MemberNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  ${TextContainer} {
    flex: 1;
    width: 0;
  }
`;

export const TeamMemberNameCell: FC<DataCellProps> = ({ member }) => {
  // Construct name from available fields with proper fallback
  let displayName: string;

  if (member.name && member.name.trim()) {
    displayName = member.name;
  } else if (member.first_name || member.last_name) {
    // Construct from first_name and last_name if name is empty
    displayName = [member.first_name, member.last_name].filter(Boolean).join(' ').trim();
  } else {
    // Fallback to email or "Not given"
    displayName = member.email || 'Not given';
  }

  return (
    <MemberNameContainer>
      <EllipsisText text={displayName}>{displayName}</EllipsisText>
      <StyledEditIcon />
    </MemberNameContainer>
  );
};
